import type { BdIntervalRelative } from '@bindoc-projects/time-domain-lib';
import type { FilterConditionDto } from './condition';
import { BdCondition } from './condition';

export abstract class BdRelativeDateIntervalCondition extends BdCondition {
  protected constructor(
    id: string,
    public intervalRelative: BdIntervalRelative,
  ) {
    super(id);
  }

  toJSON(): FilterConditionDto {
    return {
      [this.id]: {
        start: {
          count: this.intervalRelative.start.count,
          temporalUnit: this.intervalRelative.start.temporalUnit
        },
        duration: {
          count: this.intervalRelative.duration.count,
          temporalUnit: this.intervalRelative.duration.temporalUnit
        }
      }
    }
  }
}
